<template>
  <b-container fluid tag="header" class="app-desktop-header">
    <BfTitle>{{title}}</BfTitle>

    <LogoutLink />
  </b-container>
</template>

<script>
import LogoutLink from './LogoutLink';

export default {
  name: 'DesktopHeader',

  props: {
    title: {
      type: String,
    },
  },

  components: {
    LogoutLink,
  },
};
</script>

<style lang="scss" scoped>
.app-desktop-header {
  padding-top: 15px;
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
}
</style>
